import React from 'react';
import { render, waitFor } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import SearchForm from './SearchForm';

describe('SearchForm', () => {
  const onSearch = jest.fn();

  const defaultProps = {
    onSearch,
    loading: false,
    initialErrorId: '',
    initialTraceId: '',
    initialTimeRange: '24h',
  };

  const renderSearchForm = (props = {}) =>
    render(<SearchForm {...defaultProps} {...props} />);

  afterEach(() => {
    jest.clearAllMocks();
  });

  it('renders all form fields', () => {
    const { getByLabelText, getByText, getByRole } = renderSearchForm();

    expect(getByLabelText('Error ID')).toBeInTheDocument();
    expect(getByLabelText('Trace ID')).toBeInTheDocument();
    expect(getByText('Time Range')).toBeInTheDocument();
    expect(getByRole('button', { name: 'Search' })).toBeInTheDocument();
  });

  it('calls onSearch with correct values when Search is clicked', async () => {
    const { container, getByRole } = renderSearchForm();

    const errorIdInput = container.querySelector('input[name="error_id"]');
    const traceIdInput = container.querySelector('input[name="trace_id"]');

    userEvent.type(errorIdInput, 'a1b2c3d4-e5f6-7890-abcd-ef1234567890');
    userEvent.type(traceIdInput, '201617491736685022');

    userEvent.click(getByRole('button', { name: 'Search' }));

    await waitFor(() => {
      expect(onSearch).toHaveBeenCalledWith({
        errorId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
        traceId: '201617491736685022',
        timeRange: '24h',
      });
    });
  });

  it('shows validation error when Error ID is empty', async () => {
    const { getByRole, getByText } = renderSearchForm();

    userEvent.click(getByRole('button', { name: 'Search' }));

    await waitFor(() => {
      expect(getByText('Error ID is required.')).toBeInTheDocument();
    });

    expect(onSearch).not.toHaveBeenCalled();
  });

  it('shows validation error for invalid UUID format', async () => {
    const { container, getByRole, getByText } = renderSearchForm();

    const errorIdInput = container.querySelector('input[name="error_id"]');
    userEvent.type(errorIdInput, 'not-a-valid-uuid');

    userEvent.click(getByRole('button', { name: 'Search' }));

    await waitFor(() => {
      expect(
        getByText(
          'Enter a valid UUID format (e.g. a1b2c3d4-e5f6-7890-abcd-ef1234567890).',
        ),
      ).toBeInTheDocument();
    });

    expect(onSearch).not.toHaveBeenCalled();
  });

  it('triggers search on Enter key press', async () => {
    const { container } = renderSearchForm();

    const errorIdInput = container.querySelector('input[name="error_id"]');
    userEvent.type(errorIdInput, 'a1b2c3d4-e5f6-7890-abcd-ef1234567890{enter}');

    await waitFor(() => {
      expect(onSearch).toHaveBeenCalledWith({
        errorId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
        traceId: '',
        timeRange: '24h',
      });
    });
  });

  it('populates initial values from props', () => {
    const { container } = renderSearchForm({
      initialErrorId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
      initialTraceId: '201617491736685022',
      initialTimeRange: '4h',
    });

    const errorIdInput = container.querySelector('input[name="error_id"]');
    const traceIdInput = container.querySelector('input[name="trace_id"]');

    expect(errorIdInput.value).toBe('a1b2c3d4-e5f6-7890-abcd-ef1234567890');
    expect(traceIdInput.value).toBe('201617491736685022');
  });
});
